import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './AppIcon.scss'

const AppIcon = ({ url }) => (
	<div styleName="icon-wrapper">
		{url ? (
			<img src={url} styleName="icon" role="presentation" />
		) : (
			<div styleName="icon" />
		)}
	</div>
)

export default CSSModules(AppIcon, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/AppCard/AppIcon.js